import React from "react";

const PayrollCard = ({
  title,
  value,
  subtitle,
  icon,
  trend,
  trendValue,
  loading = false,
  className = "",
}) => {
  return (
    <div
      className={`bg-white dark:bg-gray-800 rounded-lg shadow-md p-4 ${className}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 dark:text-gray-400 font-poppins">
            {title}
          </p>
          {loading ? (
            <div className="mt-2 h-8 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
          ) : (
            <>
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mt-2 font-poppins">
                {value}
              </h3>
              {subtitle && (
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 font-poppins">
                  {subtitle}
                </p>
              )}
              {trend && (
                <div className="flex items-center mt-2">
                  <span
                    className={`text-sm font-medium font-poppins ${
                      trend === "up"
                        ? "text-green-600 dark:text-green-400"
                        : trend === "down"
                        ? "text-red-600 dark:text-red-400"
                        : "text-gray-600 dark:text-gray-400"
                    }`}
                  >
                    {trend === "up" ? "↑" : trend === "down" ? "↓" : "−"}{" "}
                    {trendValue}
                  </span>
                  <span className="text-xs text-gray-500 dark:text-gray-400 ml-1 font-poppins">
                    vs last month
                  </span>
                </div>
              )}
            </>
          )}
        </div>
        {icon && (
          <div className="flex-shrink-0 ml-4">
            <div className="w-12 h-12 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center">
              {icon}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PayrollCard;
